module.exports = __webpack_public_path__ + "img/软件著作权icon.5447e0cf.png";